import { createAction, props } from '@ngrx/store';
import { AppError } from 'src/app/shared/utils';
import { DashboardDto, DashboardVisualContentDto, FilterDto, ListUserDashboardDto, ListUserVisualDto, VisualDto } from '../../services/api.services';
import { DashboardVisualTarget } from 'src/app/pbir/dashboards/DashboardVisualTarget';


export const reset = createAction(
  '[Home] Reset'
);

export const load = createAction(
  '[Home] Load',
  props<{ dashboardId?: number, visualId?: number }>()
);

export const loaded = createAction(
  '[Home] Loaded'
);


export const loadDashboards = createAction(
  '[Home] Load Dashboards',
  props<{ dashboardId?: number }>()
);

export const loadDashboardsSuccess = createAction(
  '[Home] Load Dashboards Success',
  props<{ dashboards: ListUserDashboardDto[], dashboardId?: number }>()
);

export const loadDashboardsFailure = createAction(
  '[Home] Load Dashboards Failure',
  props<{ error: AppError }>()
);

export const loadVisuals = createAction(
  '[Home] Load Visuals',
  props<{ visualId?: number }>()
);

export const loadVisualsSuccess = createAction(
  '[Home] Load Visuals Success',
  props<{ visuals: ListUserVisualDto[], visualId?: number }>()
);

export const loadVisualsFailure = createAction(
  '[Home] Load Visuals Failure',
  props<{ error: AppError }>()
);

export const loadLastViewedDashboard = createAction(
  '[Home] Load Last Viewed Dashboard'
);


export const setNoItem = createAction(
  '[Home] Set No Item'
);

export const loadDashboard = createAction(
  '[Home] Load Dashboard',
  props<{ dashboardId: number }>()
);

export const loadDashboardSuccess = createAction(
  '[Home] Load Dashboard Success',
  props<{ dashboard: DashboardDto, visualContents: DashboardVisualContentDto[] }>()
);

export const loadDashboardFailure = createAction(
  '[Home] Load Dashboard Failure',
  props<{ error: AppError }>()
);

export const loadVisual = createAction(
  '[Home] Load Visual',
  props<{ visualId: number }>()
);

export const loadVisualSuccess = createAction(
  '[Home] Load Visual Success',
  props<{ visual: VisualDto}>()
);

export const loadVisualFailure = createAction(
  '[Home] Load Visual Failure',
  props<{ error: AppError }>()
);

export const setLastViewedDashboardId = createAction(
  '[Home] Set Last Viewed Dashboard Id',
  props<{ dashboardId: number }>()
);

export const setLastViewedVisualId = createAction(
  '[Home] Set Last Viewed Visual Id',
  props<{ visualId: number }>()
);

export const setFocusedVisual = createAction(
  '[Home] Set Focused Visual',
  props<{ visual: DashboardVisualTarget }>()
);


export const userDashboardOrVisualChanged = createAction(
  '[Home] User Dashboard Or Visual Changed',
);


export const editDashboard = createAction(
  '[Home] Edit Dashboard',
  props<{ dashboardId?: number, editFilters?: boolean }>()
);


export const copyDashboard = createAction(
  '[Home] Copy Dashboard',
  props<{ dashboardId?: number }>()
);

export const copyDashboardSuccess = createAction(
  '[Home]] Copy Dashboard Success',
  props<{ dashboard: ListUserDashboardDto }>()
);

export const copyDashboardFailure = createAction(
  '[Home] Copy Dashboard Failure',
  props<{ error: AppError }>()
);

export const copyVisual = createAction(
  '[Home] Copy Visual',
  props<{ visualId?: number }>()
);

export const copyVisualSuccess = createAction(
  '[Home]] Copy Visual Success',
  props<{ visual: VisualDto }>()
);

export const copyVisualFailure = createAction(
  '[Home] Copy Visual Failure',
  props<{ error: AppError }>()
);


export const addDashboard = createAction(
  '[Home] Add Dashboard',
  props<{ dashboardId: number }>()
);

export const addDashboardSuccess = createAction(
  '[Home] Add Dashboard Success',
  props<{ dashboardId: number }>()
);

export const addDashboardFailure = createAction(
  '[Home] Add Dashboard Failure',
  props<{ error: AppError }>()
);

export const addVisual = createAction(
  '[Home] Add Visual',
  props<{ visualId: number }>()
);

export const addVisualSuccess = createAction(
  '[Home] Add Visual Success',
  props<{ visualId: number }>()
);

export const addVisualFailure = createAction(
  '[Home] Add Visual Failure',
  props<{ error: AppError }>()
);


export const exportDashboardToPdf = createAction(
  '[Home] Export Dashboard To Pdf',
  props<{ filters?: FilterDto[] }>()
);

export const exportVisual = createAction(
  '[Home] Export Visual',
  props<{ filters?: FilterDto[] }>()
);
